import clsx from 'clsx'
import React from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import {ArrowLeftIcon, ArrowRightIcon} from '../../../resources/icons'

const useStyles = makeStyles(navigationStyles)
 
export default function Navigation ({sections, context}) {

  const {questionId, sectionId, translate} = context

  const link = (sectionId, questionId) => context.link({sectionId, questionId})

  const classes = useStyles()

  const sectionIndex = sections.findIndex(s => s.id == sectionId)
  const section = sectionIndex >= 0 && sections[sectionIndex]

  const questionIndex = questionId && section ? section.questions.findIndex(q => q.id == questionId) : -1

  const question = questionIndex >= 0 && section.questions[questionIndex]

  const isFirst = !questionId && sectionIndex == 0

  const isLastSection = sectionIndex == sections.length - 1
  const isLastQuestion = section && questionIndex == section.questions.length - 1

  const isLast = isLastSection && isLastQuestion

  const nextTo = () => {

    if (!section) return '#'

    if (questionId)
      return isLastQuestion
        ? link(sections[sectionIndex + 1].id)
        : link(sectionId, section.questions[questionIndex + 1].id)

    return link(sectionId, section.questions[0].id)

  }

  const previousTo = () => {
    if (!section) return '#'
    if (questionId)
      return questionIndex == 0
        ? link(sectionId)
        : link(sectionId, section.questions[questionIndex - 1].id)

    const previousSection = sections[sectionIndex - 1]
    const lastQuestion = previousSection.questions[previousSection.questions.length - 1]
    if (lastQuestion) return link(previousSection.id, lastQuestion.id)
    return '#'
  }

  function handleFinalize () {
  }


  return (
    <Box className={classes.root}>
      <Box className="filler" />
      <Box className={classes.buttons}>
        {!isFirst && (
          <NavigationButton name="previous" to={previousTo()}>
              <Box className={classes.buttonIcon}><ArrowLeftIcon width="16px" height="25px" fill="#6278f0"/></Box>
              <Box className={clsx(classes.buttonLabel, "previous")}>{translate('previous')}</Box>
          </NavigationButton>
        )}
        {!isLast && (
          <NavigationButton name="next" to={nextTo()}>
            <Box className={clsx(classes.buttonLabel, "next")}>{translate('next')}</Box>
            <Box className={classes.buttonIcon}><ArrowRightIcon width="16px" height="25px" fill="#6278f0"/></Box>
          </NavigationButton>
        )}
      </Box>
    </Box>
  )
}

function NavigationButton (props) {
  const {name, onClick, to} = props
  const classes = useStyles()
  const Elem = to ? Link : Box
  return ( 
    <Elem to={to} onClick={onClick} className={clsx(classes.button, name)}>
      {props.children}
    </Elem>
  )
}

function navigationStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      display: 'flex',
      "& .filler" : {
        flexGrow: 1
      }
    },
    buttons: {
      display: 'flex'
    },
    button : {
      display: 'flex',
      padding: '5px',
      fontSize: '12pt',
      backgroundColor: '#f0f0f0',
      color: '#6278f0',
      borderRadius: 3,
      width: 110,
      textDecoration: 'none',
      "&:last-child": {
        marginLeft: 20
      },
    },
    buttonLabel: {
      flexGrow: 1,
      ...verticalCentering,
      textAlign: 'center',
    },
    buttonIcon: {
      ...verticalCentering
    }
  }
}
